import { render, staticRenderFns } from "./FloorInfo.vue?vue&type=template&id=3b6c3029&"
import script from "./FloorInfo.vue?vue&type=script&lang=js&"
export * from "./FloorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports